import React, { useState } from 'react';
import { SimplifiedCooldown } from '../../../../../gameTypes';
import './CooldownDebugTable.css';

interface CooldownDebugTableProps {
  cooldowns: SimplifiedCooldown[];
}

const CooldownDebugTable: React.FC<CooldownDebugTableProps> = ({ cooldowns }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!cooldowns || cooldowns.length === 0) {
    return (
      <div className="cooldown-debug-table">
        <div className="cooldown-header" onClick={() => setIsExpanded(!isExpanded)}>
          <span>🛠️ Cooldowns (0)</span>
          <span className={`arrow ${isExpanded ? 'expanded' : ''}`}>▼</span>
        </div>
      </div>
    );
  }

  const activeCooldowns = cooldowns.filter(cd => cd.isOnCooldown);

  return (
    <div className="cooldown-debug-table">
      <div className="cooldown-header" onClick={() => setIsExpanded(!isExpanded)}>
        <span>🛠️ Cooldowns ({activeCooldowns.length}/{cooldowns.length})</span>
        <span className={`arrow ${isExpanded ? 'expanded' : ''}`}>▼</span>
      </div>
      
      {isExpanded && (
        <div className="cooldown-content">
          <div className="cooldown-section">
            <div className="cooldown-grid-header">
              <span className="header-key">Key</span>
              <span className="header-name">Name</span>
              <span className="header-original">Max CD</span>
              <span className="header-current">Current</span>
              <span className="header-type">Type</span>
            </div>
            <div className="cooldown-grid">
              {cooldowns.map((cooldown, index) => (
                <div 
                  key={`cooldown-${index}`} 
                  className={`cooldown-row ${cooldown.isOnCooldown ? 'on-cooldown' : 'available'}`}
                >
                  <span className="cooldown-key">{cooldown.key}</span>
                  <span className="cooldown-name" title={cooldown.name}>{cooldown.name}</span>
                  <span className="cooldown-original">
                    {cooldown.totalDuration != null ? `${cooldown.totalDuration.toFixed(1)}s` : 'N/A'}
                  </span>
                  <span className="cooldown-current">
                    {cooldown.isOnCooldown 
                      ? `${(cooldown.remainingTime || 0).toFixed(1)}s`
                      : 'Ready'
                    }
                  </span>
                  <span className="cooldown-type">{cooldown.type}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CooldownDebugTable; 